 /*
 * @Author: mayqiyue 
 * @Date: 2019-06-17 15:12:26 
 * @Last Modified by: mayqiyue
 * @Last Modified time: 2019-06-17 15:12:53
 * https://github.com/chenqingspring/vue-lottie
 */

<template>
  <div :style="style" ref="lavContainer"></div>
</template>

<script>
import lottie from 'lottie-web';

export default {
  props: {
    options: {
      type: Object,
      required: true
    },
    height: Number,
    width: Number,
  },

  data() {
    return {
      style: {
        width: this.width ? `${this.width}px` : '100%',
        height: this.height ? `${this.height}px` : '100%',
        overflow: 'hidden',
        margin: '0 auto'
      }
    }
  },

  mounted() {
    const data = (this.options.animationData).default;
    data.assets.forEach((item, index) => {
      item.u = "";
      item.p = require(`@/assets/lotties/vip-video/images/img_${index}.png`);
    });

    this.anim = lottie.loadAnimation({
      container: this.$refs.lavContainer,
      renderer: 'svg',
      loop: this.options.loop !== false,
      autoplay: this.options.autoplay !== false,
      animationData: data,
      rendererSettings: this.options.rendererSettings
    }
    );
    this.$emit('animCreated', this.anim)
  }
}
</script>
